// Iter 51 — Dashboard "no trades logged yet" empty state. Pulled out of
// Dashboard.jsx so the main file isn't dominated by the empty-flow JSX.
import React from "react";
import { Link } from "react-router-dom";

export default function DashboardEmptyState() {
  return (
    <div className="space-y-8" data-testid="dashboard-page">
      <div>
        <p className="bt-label">Overview</p>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tight">Dashboard</h1>
      </div>
      <div
        data-testid="dashboard-empty-state"
        className="border border-dashed rounded-xl py-20 px-8 text-center flex flex-col items-center"
        style={{ background: "#0a0a0a", borderColor: "#1e1e1e" }}
      >
        <div className="text-7xl mb-6" aria-hidden>📊</div>
        <h2 className="font-heading text-3xl text-white mb-2">
          Your trading story starts here
        </h2>
        <p className="text-[var(--bt-text-muted)] max-w-md mb-8 text-base leading-relaxed">
          Log your first trade to unlock your performance analytics,
          Signal vs Self score, and AI insights.
        </p>
        <Link
          to="/trades/new"
          data-testid="empty-state-add-trade-btn"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md font-bold text-black transition-all duration-150 ease-out"
          style={{
            background: "#00ff88",
            boxShadow: "0 0 24px rgba(0, 255, 136, 0.35)",
          }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}
        >
          + Log Your First Trade
        </Link>
      </div>
    </div>
  );
}
